import { render, staticRenderFns } from "./AboutusWap.vue?vue&type=template&id=04dbe2e4&scoped=true"
import script from "./AboutusWap.vue?vue&type=script&lang=js"
export * from "./AboutusWap.vue?vue&type=script&lang=js"
import style0 from "./AboutusWap.vue?vue&type=style&index=0&id=04dbe2e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dbe2e4",
  null
  
)

export default component.exports